const getters = {
  getChats: (state) => state.chats.data,
  getSelectedRoom: (state) => state.selectedRoom,
  getRooms: (state) => state.room.data,
  getHeader: (state) => state.header,
  shouldIMoveScroll: (state) => state.shouldIMoveScroll
};
export default getters;
